import React from 'react';
import i18n from '../../translations/i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import braintree_logo from '../../images/braintree_logo.png';
import paypal_logo from '../../images/paypal_logo.png';
import iso_logo from '../../images/iso_logo.jpg';
import ata_logo from '../../images/ATA_logo.jpg';
import gocardless_logo from '../../images/gocardless.jpg';

let OrderDetails = props => {
	const { items, lng, qty } = props;
	let showItems = items.length!==0;
	const itemsArray = items.map((value, index) => {
		return(
			<dd key={index} className="text-left"><span className="orange">✓</span> {value} x {qty[value]}</dd>
		)
	})
	return (
		<div>
		{showItems&&
			<div className="title title-border title-border text-left mt-5 mb-3">
				<h6 className="font-italic">{i18n.t('sidecard.your_order', {lng})}</h6>
			</div>}
			<div className="small-text-bold orange">{itemsArray}</div>
		</div>
	)
}

let OrderPrice = props => {
	let lng = props.lng;
	let currencySign = (props.currency === "EUR") ? "€" : (props.currency === "GBP") ? "£" : "$"

	let price = (props.price==="Unavailable") ? i18n.t('sidecard.price_unavailable', {lng}) : props.price
	let showCurrency = (props.price==="Unavailable") ? false: true

	if (props.priceRefresh===1) {
		return (
			<div className="text-center">
				<FontAwesomeIcon icon={faSpinner} color="#0D3680" size="xs" spin/>
			</div>
		)
	} else if (showCurrency) {
		return (
			<div className="row">
				<div className="price-display mx-auto">
					<h4><strong>{price} <sup>{currencySign}</sup></strong></h4>
				</div>
			</div>
		)
	} else {
		return (
			<div className="row">
				<div className="price-display mx-auto">
					<h5>{price}</h5>
				</div>
			</div>
		)
	}
	
}

let FinalOrderPrice = props => {
	let price = (props.price==="Unavailable") ? 0 : props.price
	let currencySign = (props.currency === "EUR") ? "€" : (props.currency === "GBP") ? "£" : "$"
	return (
		<div className="row">
			<div className="c60"></div>
			<div className="text-right c40">
				<h4><strong>{price} <sup>{currencySign}</sup></strong></h4>
			</div>
		</div>
	)
}

let CouponDisplay = props => {
	let lng = props.lng;
	let currencySign = (props.currency === "EUR") ? "€" : (props.currency === "GBP") ? "£" : "$"
	return (
		<div>
			{props.coupon!==0&&
			<div className="row subtotal">
				<div className="c70 pl-3"><span>- {i18n.t('sidecard.coupon', {lng})}</span></div>
				<div className="text-right c30">
					<h5>{props.coupon} <sup>{currencySign}</sup></h5>
				</div>
			</div>}
		</div>
	)
}

let VATCalculation = props => {
	let lng = props.lng;
	let currencySign = (props.currency === "EUR") ? "€" : (props.currency === "GBP") ? "£" : "$"
	return (
		<div>
			{props.vatDisplay&&
			<div className="row subtotal">
				<div className="c70 pl-3"><span>+ {i18n.t('sidecard.vat', {lng})}</span></div>
				<div className="text-right c30">
					<h5>{props.vat} <sup>{currencySign}</sup></h5>
				</div>
			</div>}
		</div>
	)
}

let TransactionFeeSection = props => {
	let lng = props.lng;
	let currencySign = (props.currency === "EUR") ? "€" : (props.currency === "GBP") ? "£" : "$"
	return (
		<div>
			{props.transactionFee > 0 &&
			<div className="row subtotal">
				<div className="c70 pl-3"><span>+ {i18n.t('sidecard.transaction_fee', {lng})}</span></div>
				<div className="text-right c30">
					<h5>{props.transactionFee} <sup>{currencySign}</sup></h5>
				</div>
			</div>}
		</div>
	)
}

let DeadlineRow = props => {
	let currencySign = (props.currency === "EUR") ? "€" : (props.currency === "GBP") ? "£" : "$"
	let urgencyPercent = (props.deadlinePercent * 100);
	let showPercent = false;
	if (urgencyPercent < 0) {
		showPercent = true;
	}
	return (
		<div>
			<div className="row subtotal">
				<div className="c70 pl-3">
					<span>+ {props.deadlineName}</span>
					{showPercent&&<span> ({urgencyPercent} %)</span>}
				</div>
				<div className="text-right c30">
					<h5>{props.deadline} <sup>{currencySign}</sup></h5>
				</div>
			</div>
		</div>
	)
}

let DeliveryRow = props => {
	let lng = props.lng;
	let currencySign = (props.currency === "EUR") ? "€" : (props.currency === "GBP") ? "£" : "$"
	return (
		<div>
			<div className="row subtotal">
				<div className="c70 pl-3"><span>+ {i18n.t('sidecard.delivery', {lng})}</span></div>
				<div className="text-right c30">
					<h5>{props.delivery} <sup>{currencySign}</sup></h5>
				</div>
			</div>
		</div>
	)
}

let TotalRow = props => {
	let lng = props.lng;
	let currencySign = (props.currency === "EUR") ? "€" : (props.currency === "GBP") ? "£" : "$"
	return (
		<div>
			<div className="row total-amount pt-2">
				<div className="c60 pl-3"><h5>{i18n.t('sidecard.total', {lng})}</h5></div>
				<div className="text-right c40">
					<h5>{props.total} <sup>{currencySign}</sup></h5>
				</div>
			</div>
		</div>
	)
}

const PrivacySection = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.privacy_subtitle', {lng})}</h6>
			</div>
			<div className="small-text">
				<p>{i18n.t('sidecard.privacy_text', {lng})}</p>
			</div>
		</div>
	)
}

const DisclaimerSection = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
					<h6 className="font-italic">{i18n.t('sidecard.step4_subtitle1', {lng})}</h6>
			</div>
			<div className="small-text">
				<p>{i18n.t('sidecard.step4_text1', {lng})}</p>
			</div>
		</div>
	)
}

const TranslationInfo = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.translation', {lng})}</h6>
			</div>
			<dl className="small-text-bold orange">
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.translation_info_1', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.translation_info_2', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.translation_info_3', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.translation_info_4', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.translation_info_5', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.translation_info_6', {lng})}</dd>
			</dl>
		</div>
	)
}

const OfficialTranslationInfo = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.official_translation', {lng})}</h6>
			</div>
			<p className="text-left">{i18n.t('sidecard.official_translation_info_text', {lng})}</p>
			<dl className="small-text-bold orange">
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.official_translation_info_1', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.official_translation_info_2', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.official_translation_info_3', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.official_translation_info_4', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.official_translation_info_5', {lng})}</dd>
			</dl>
		</div>
	)
}

const InterpretingInfo = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.interpreting', {lng})}</h6>
			</div>
			<dl className="small-text-bold orange">
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.interpreting_info_1', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.interpreting_info_2', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.interpreting_info_3', {lng})}</dd>
			</dl>
		</div>
	)
}


const CoachingInfo = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.coaching', {lng})}</h6>
			</div>
			<dl className="small-text-bold orange">
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.coaching_info_1', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.coaching_info_2', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.coaching_info_3', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.coaching_info_4', {lng})}</dd>
			</dl>
		</div>
	)
}

const ProfessionalInfo = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.professional', {lng})}</h6>
			</div>
			<dl className="small-text-bold orange">
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.professional_info_1', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.professional_info_2', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.professional_info_3', {lng})}</dd>
			</dl>
			<p className="small-text text-left">{i18n.t('sidecard.professional_footer', {lng})}</p>
		</div>
	)
}

const PremiumInfo = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.premium', {lng})}</h6>
			</div>
			<dl className="small-text-bold orange">
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.premium_info_1', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.premium_info_2', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.premium_info_3', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.premium_info_4', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.premium_info_5', {lng})}</dd>
			</dl>
			<p className="small-text text-left">{i18n.t('sidecard.premium_footer', {lng})}</p>
		</div>
	)
}

const BasicInfo = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.basic', {lng})}</h6>
			</div>
			<dl className="small-text-bold orange">
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.basic_info_1', {lng})}</dd>
				<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.basic_info_2', {lng})}</dd>
			</dl>
			<p className="small-text text-left">{i18n.t('sidecard.basic_footer', {lng})}</p>
		</div>
	)
}

const SwornInfo = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.sworn', {lng})}</h6>
			</div>
			<p className="small-text text-left">{i18n.t('sidecard.sworn_footer', {lng})}</p>
		</div>
	)
}

const ConsecutiveInfo = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.consecutive', {lng})}</h6>
			</div>
			<p className="small-text text-left">{i18n.t('sidecard.consecutive_footer', {lng})}</p>
		</div>
	)
}

const SimultaneousInfo = (props) => {
	let lng = props.lng;
	return (
		<div>
			<div className="title title-border title-border text-left mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.simultaneous', {lng})}</h6>
			</div>
			<p className="small-text text-left">{i18n.t('sidecard.simultaneous_footer', {lng})}</p>
		</div>
	)
}

const Logos = () => {
	let mainStyle = { maxWidth: "300px", marginTop: "30px" }
	let imgStyle1 = { maxWidth: "100%" }
	let imgStyle2 = { maxWidth: "60%" }
	let imgStyle3 = { maxWidth: "40%" }
	return (
		<div className="mx-auto" style={mainStyle}>
			<div className="text-center">
				<img style={imgStyle1} src={braintree_logo} alt="Braintree"></img>
			</div>
			<div className="text-center">
				<img style={imgStyle1} src={paypal_logo} alt="Paypal"></img>
			</div>
			<div className="text-center">
				<img style={imgStyle1} src={gocardless_logo} alt="GoCardless"></img>
			</div>
			<div className="text-center">
				<img style={imgStyle2} src={iso_logo} alt="ISO 9001:2005"></img>
				<img style={imgStyle3} src={ata_logo} alt="ATA Logo"></img>
			</div>
		</div>
	)
}

const ShopperApproved = (props) => {
	let mainStyle = { border: 0 }
	let lng = props.lng;

	function shopperApprovedContextMenu(e) {
		var d = new Date();
		alert('Copying Prohibited by Law - This image and all included logos are copyrighted by Shopper Approved © '+d.getFullYear()+'.');
		return false;
	}

	return (
		<div>
			<div className="title title-border title-border text-center mt-5">
				<h6 className="font-italic">{i18n.t('sidecard.shopper_approved', {lng})}</h6>
			</div>
			<div className="mt-2 text-center">
				<a href="https://www.shopperapproved.com/reviews/davrontranslations.com/" className="shopperlink">
					<img src="//www.shopperapproved.com/newseals/32976/white-mini-icon.gif" style={mainStyle} alt="Customer Reviews" onContextMenu={shopperApprovedContextMenu} />
				</a>
			</div>
		</div>
	)
}


let SideCard = props => {
	let {vat, deliveryPrice, deadlinePrice, totalPrice, calculatedPrice, lng, vatDisplay, coupon, transactionFee} = props;
	let deadlineName = props.urgencyName;

	if (props.page===0||props.page===1){
		return (
			<div>
				<div className="title title-border title-border text-left mb-3">
					<h5>{i18n.t('sidecard.step1_title', {lng})}</h5>
				</div>
				<dl className="small-text-bold orange">
					<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.step1_line1', {lng})}</dd>
					<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.step1_line2', {lng})}</dd>
					<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.step1_line3', {lng})}</dd>
					<dd className="text-left"><span className="orange">✓</span> {i18n.t('sidecard.step1_line4', {lng})}</dd>
				</dl>
				<PrivacySection 
					lng={lng}
				/>
				<Logos />
				<ShopperApproved 
					lng={lng}
				/>
			</div>
		)
	} else if (props.page===2){
		return (
			<div>
				<OrderPrice
					currency={props.currency}
					price={calculatedPrice}
					lng={props.lng}
					priceRefresh={props.priceRefresh}
				/>
				<OrderDetails 
					items={props.items}
					qty={props.qty}
					lng={props.lng}
				/>
				{props.form.values.service === "translation" && <TranslationInfo lng={props.lng}/>}
				{props.form.values.service === "official" && <OfficialTranslationInfo lng={props.lng}/>}
				{props.form.values.service === "interpreting" && <InterpretingInfo lng={props.lng}/>}
				{props.form.values.service === "coaching" && <CoachingInfo lng={props.lng}/>}
				{props.form.values.service === "interpreting" && ["Assermentée", "Sworn"].includes(props.form.values.interpretingType) && <SwornInfo lng={props.lng}/>}
				{props.form.values.service === "interpreting" && ["Consécutive", "Consecutive"].includes(props.form.values.interpretingType) && <ConsecutiveInfo lng={props.lng}/>}
				{props.form.values.service === "interpreting" && ["Simultanée", "Simultaneous"].includes(props.form.values.interpretingType) && <SimultaneousInfo lng={props.lng}/>}
				{props.items.length===0&&<PrivacySection 
					lng={lng}
				/>}
				{props.items.length===0&&<Logos />}
				{props.items.length===0&&<ShopperApproved
					lng={lng}
				/>}
			</div>
		)
	} else if (props.page===3){
		let showDeliveryDeadline = (props.form.values.service==="translation"||props.form.values.service==="official") ? true: false
		return (
			<div>
				{(props.price!=="Unavailable")&&<div>
				<FinalOrderPrice
					currency={props.currency}
					price={calculatedPrice}
					lng={props.lng}
				/>
				{showDeliveryDeadline&&<DeliveryRow 
					lng={props.lng}
					currency={props.currency}
					delivery={deliveryPrice}
				/>}
				{showDeliveryDeadline&&<DeadlineRow 
					lng={props.lng}
					currency={props.currency}
					deadline={deadlinePrice}
					deadlineName={deadlineName}
					deadlinePercent={props.urgencyFactor}
				/>}
				<TotalRow
					lng={props.lng}
					currency={props.currency}
					total={totalPrice}
				/>
				</div>}
				{(props.price==="Unavailable")&&<div className="text-center">
				<h5>{i18n.t('sidecard.price_unavailable', {lng})}</h5>
				</div>}
				<OrderDetails 
					items={props.items}
					qty={props.qty}
					lng={props.lng}
				/>
				{props.form.values.service === "translation" && props.form.values.translationLevel === "professional" && <ProfessionalInfo lng={props.lng}/>}
				{props.form.values.service === "translation" && props.form.values.translationLevel === "premium" && <PremiumInfo lng={props.lng}/>}
				{props.form.values.service === "translation" && props.form.values.translationLevel === "basic" && <BasicInfo lng={props.lng}/>}
			</div>
		)
	} else if (props.page>=4){

		let showDeliveryDeadline = (props.form.values.service==="translation"||props.form.values.service==="official") ? true: false
		return (
			<div>
				{(props.price!=="Unavailable")&&<div>
				<FinalOrderPrice
					currency={props.currency}
					price={calculatedPrice}
					lng={props.lng}
				/>
				{showDeliveryDeadline&&<DeliveryRow 
					lng={props.lng}
					currency={props.currency}
					delivery={deliveryPrice}
				/>}
				{showDeliveryDeadline&&<DeadlineRow 
					lng={props.lng}
					currency={props.currency}
					deadline={deadlinePrice}
					deadlineName={deadlineName}
					deadlinePercent={props.urgencyFactor}
				/>}
				<CouponDisplay 
					lng={props.lng}
					currency={props.currency}
					coupon={coupon}
				/>
				<TransactionFeeSection
					lng={props.lng}
					currency={props.currency}
					transactionFee={transactionFee}
				/>
				<VATCalculation 
					lng={props.lng}
					currency={props.currency}
					vat={vat}
					vatDisplay={vatDisplay}
				/>
				<TotalRow
					lng={props.lng}
					currency={props.currency}
					total={totalPrice}
				/>
				</div>}
				{(props.price==="Unavailable")&&<div className="text-center">
				<h5>{i18n.t('sidecard.price_unavailable', {lng})}</h5>
				</div>}
				<OrderDetails 
					items={props.items}
					qty={props.qty}
					lng={props.lng}
				/>
				<DisclaimerSection
					lng={props.lng}
				/>
				<PrivacySection 
					lng={props.lng}
				/>
				<Logos />
				<ShopperApproved 
					lng={props.lng}
				/>
			</div>
		)
	}
}
export default SideCard


// WEBPACK FOOTER //
// ./src/components/common/sideCard.js